import React from 'react';
import { FieldLayoutContainer } from './styles/field-layout.styled';
export const FieldLayout = ({ children }) => {
    return React.createElement(FieldLayoutContainer, null, children);
};
//# sourceMappingURL=FieldLayout.js.map